import { useState } from "react";
import { Link } from "react-router-dom";
import { Newsletter } from "../components";
import { POSTS, CATEGORIES } from "../data/content";

export default function Blog() {
  const [active, setActive] = useState("All");

  const filtered = active === "All" ? POSTS : POSTS.filter(p => p.category === active);

  return (
    <div className="page">
      <div className="page-hero">
        <div className="page-eyebrow">The Journal</div>
        <h1 className="page-title">Stories from<br />Down Under</h1>
        <p className="page-subtitle">
          Visa journeys, Melbourne life, travel guides, career tips - the honest stuff nobody tells you before you move.
        </p>
      </div>

      <div className="filter-bar">
        {CATEGORIES.map(cat => (
          <button
            key={cat}
            className={`filter-btn${active === cat ? " active" : ""}`}
            onClick={() => setActive(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="posts-list" style={{ padding: "1.5px" }}>
        {filtered.map(post => (
          <Link to={`/blog/${post.slug}`} className="post-list-card" key={post.id}>
            <div className="post-category">{post.category}</div>
            <h2 className="post-title" style={{ fontSize: "1.3rem", marginBottom: "0.6rem" }}>{post.title}</h2>
            <p className="post-excerpt">{post.excerpt}</p>
            <div className="post-meta" style={{ marginTop: "1rem" }}>
              <span>{post.date}</span>
              <span className="meta-dot" />
              <span>{post.readTime}</span>
              {post.tags?.map(t => (
                <span key={t} className="post-tag" style={{ marginLeft: "0.25rem" }}>{t}</span>
              ))}
            </div>
          </Link>
        ))}
      </div>

      <Newsletter />
    </div>
  );
}
